/**
* @ngdoc service
* @name common.service:ItxSocialLoginSvc
* @description
* Social Login Service
*/
(function() {
    'use strict';

    angular
    .module('itxApp.common')
    .service('ItxSocialLoginSvc', ItxSocialLoginSvc);
    
    ItxSocialLoginSvc.$inject = ['$q', 'CmsConfigSvc'];
    
    function ItxSocialLoginSvc ($q, CmsConfigSvc) {
		var _this = this;

        var service =  {
			checkSocialLogin: checkSocialLogin
        };
         
        return service;
		
		/**
        * @ngdoc method
        * @name checkSocialLogin
        * @methodOf common.service:ItxSocialLoginSvc
        * @description Mira si tenemos algun tipo de login Social
        */
	   
		function checkSocialLogin() {
            var deferred = $q.defer();
            
            if (inditex.iStoreJSON.configurations) {
                inditex.iStoreJSON.configurations.find(function (config) {
                   if(config.parametro === 'FACEBOOK_LOGIN_ENABLED') {
                       _this.facebookLoginEnabled = config;
                   }
               });
           }

           if(_this.facebookLoginEnabled && _this.facebookLoginEnabled.valor === '1'){
            deferred.resolve(true);   
           } else {
               // check if naver login is enabled
               CmsConfigSvc.getProperty('naver_login').then(function(res){
                   if(res){
                        deferred.resolve(true);
                   } else {
                       // check if apple login is enabled
                       CmsConfigSvc.getProperty('APPLE_LOGIN_ENABLED').then(function(res){
                           if(res){
                                deferred.resolve(true);
                           } else {
                                deferred.resolve(false);
                           }
                       });
                   }
               });
           }

            return deferred.promise;

		}
    }
        
})();